import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useCMS } from '../context/CMSContext';

const Navbar = () => {
  const { settings, pages } = useCMS();
  const [isOpen, setIsOpen] = useState(false);
  const s = (key, fallback) => settings[key] || fallback;

  // Use dynamic pages from CMS, or fallback to default pages if API is offline
  const links = pages && pages.length > 0
    ? pages
        .filter(p => p.status === 'Published' && p.slug !== '/admin')
        .map(p => ({
          name: p.title,
          path: p.slug
        }))
    : [
        { name: 'Home', path: '/' },
        { name: 'About Us', path: '/about' },
        { name: 'Initiatives', path: '/initiatives' },
        { name: 'Impact', path: '/impact' },
        { name: 'Partnership', path: '/partnership' },
        { name: 'Team', path: '/team' },
        { name: 'News', path: '/news' }
      ];

  return (
    <nav className="sticky top-0 z-50 bg-brandWhite/80 backdrop-blur-md border-b border-brandBeige shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <NavLink to="/" className="flex items-center" onClick={() => setIsOpen(false)}>
            <img src="/images/eunikarelogo.png" alt="Eunikare International" className="h-14 sm:h-16 lg:h-18 w-auto object-contain" />
          </NavLink>
          
          <div className="hidden md:flex space-x-8 items-center">
            {links.map((link) => (
              <NavLink
                key={link.name}
                to={link.path}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors hover:text-brandGreen ${
                    isActive ? 'text-brandGreen underline underline-offset-8' : 'text-brandBlack/70'
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}
            <NavLink to="/partnership" className="bg-brandGreen text-brandWhite px-6 py-2 rounded-full text-sm font-bold hover:bg-brandBlack transition-all shadow-md active:scale-95">
              {s('navbar_cta', 'Get Involved')}
            </NavLink>
          </div>

          <div className="md:hidden">
            <button 
              onClick={() => setIsOpen(!isOpen)}
              className="text-brandBlack p-2 focus:outline-none" 
              aria-label="Toggle Navigation"
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Drawer Menu */}
      {isOpen && (
        <div className="md:hidden bg-brandWhite/95 backdrop-blur-md border-b border-brandBeige animate-in fade-in slide-in-from-top duration-300">
          <div className="px-4 pt-2 pb-6 space-y-2 flex flex-col items-center">
            {links.map((link) => (
              <NavLink
                key={link.name}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `w-full text-center py-3 text-base font-semibold transition-colors hover:text-brandGreen rounded-xl ${
                    isActive ? 'text-brandGreen bg-brandGreen/5' : 'text-brandBlack/70 hover:bg-brandBeige/40'
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}
            <NavLink 
              to="/partnership" 
              onClick={() => setIsOpen(false)}
              className="w-full text-center bg-brandGreen text-brandWhite py-3 rounded-full text-base font-bold hover:bg-brandBlack transition-all shadow-md mt-4 active:scale-95"
            >
              {s('navbar_cta', 'Get Involved')}
            </NavLink>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
